import React, { Fragment, memo, useEffect, useState, useRef } from 'react';
import { useHistory, withRouter } from 'react-router-dom';

import ListaAsientosInt from './listaAsientosInt.jsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUndoAlt, faCheck, faSync, faPencilAlt, faPrint, faDownload, faUpload, faTimes, faDigitalTachograph, faCheckDouble, faCalendarAlt,faListAlt } from '@fortawesome/free-solid-svg-icons';
import { farmatearFechaEstandarHora, addDays, farmatearMontos, fechaPrimerDia, fechaUltimoDia, listaRangoNumeros, itemSelect } from '../../../components/Util/Util.jsx';
import Config from '../../../components/Util/constantes.js';
import { SiteRutas } from '../../../request/RutasConfig.jsx';
import {
    TipoAsiento_Listar_Request, EncabezadoAsiento_Listar_Request,
    EncabezadoAsiento_ModificarEstado_Request, EncabezadoAsiento_Reversar_Request,
    EncabezadoAsiento_CambiarMes_Request, EncabezadoAsiento_Aplicar_Request, EncabezadoAsiento_ExportarAExcel_Request
} from '../../../request/MantenimientosRequest.jsx';
import { Empresa_Consulta_Request } from "../../../request/SeguridadRequest.jsx";
import { useSessionStorage } from '../../../components/Util/Hooks/useSessionStorage.jsx';
import { Notificacion } from '../../../components/Util/Notificacion/Notificacion.jsx';
import ModalSpinner from '../../../components/UI/modalSpinner/modalSpinner.jsx';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";

import BotonArriba from '../../../components/UI/botonArriba/botonArriba.jsx';
import ModalReversion from './modalReversion.jsx';
import ModalMoverMes from './modalMoverMes.jsx';
//Seguridad
import Session from '../../../components/Util/session/index.jsx';
import LocalStorage from '../../../components/Util/localStorage/index.jsx';
import { Obtener_MenuOpciones_Lista_Request, Obtener_MenuNombre_Request } from "../../../request/MenuRequest.jsx"
import ModalSeguridad from "../../Seguridad/ModalSeguridad.jsx";
import optSeg from '../../../components/Util/seg-menu-opciones.js';
import moment from 'moment';

function listaAsientos(props) {
    let historyMenu = useHistory();
    const [listaGralAs, setListaGralAs] = useState([]);
    const mounted = useRef();
    const [empresa, setEmpresa] = useSessionStorage('empresaCON', 0);
    const [datosEmpresa, setDatosEmpresa] = useState(undefined);
    const [token, setToken] = useSessionStorage('tokenCON', '');
    const [usuario, setUsuario] = useSessionStorage('usuarioCON');
    const _AnnoActual = new Date().getFullYear();
    const _ListaAnnos = listaRangoNumeros(Config.anoAntiguedad, _AnnoActual);
    const columnasAS = [
        { dataField: 'pNumero', text: 'Número', csvText: 'No Accion', hidden: false, sort: true, editable: false },
        { dataField: 'Digitado', text: 'Digitado', hidden: false, sort: true,align: 'center', formatter: (row, cell) => { return farmatearFechaEstandarHora(new Date(cell.Digitado)) }, editable: false },
        { dataField: 'Descripcion', text: 'Descripción', classes: "ColumnText", csvText: 'Descripcion', hidden: false, sort: true, editable: false },
        { dataField: 'Debitos', text: 'Débitos', csvText: 'Debitos', hidden: false, sort: true, align: 'right', formatter: (row, cell) => { return farmatearMontos(cell.Debitos) }, editable: false, style: { color: 'red' } },
        { dataField: 'Creditos', text: 'Créditos', csvText: 'Creditos', hidden: false, sort: true, align: 'right', formatter: (row, cell) => { return farmatearMontos(cell.Creditos) }, editable: false, style: { color: 'blue' } },
        { dataField: 'llave', text: 'llave', hidden: true, sort: true, editable: false, csvExport: false },
    ];

    const datosConst = {
        Estado: { value: '', attributes: { readOnly: false, focus: false, label: 'Estado', hidden: 'unset' } },
        TipoAS: { value: '', attributes: { readOnly: false, focus: false, label: 'Tipo Asiento', hidden: 'unset' } },
        AccionPers: { value: '', attributes: { readOnly: false, focus: false, label: 'Acción personal', hidden: 'unset' } },
        fecMesAno: { value: addDays(new Date(), -30), attributes: { readOnly: false, focus: false, label: 'Fecha', hidden: 'unset', minDate: fechaPrimerDia(new Date(Config.anoAntiguedad, 0, 1)), maxDate: fechaUltimoDia(new Date(_AnnoActual, 11, 1)), ListaAnnos: _ListaAnnos, formatDate: Config.formatoMesAno } },
        BotonesAS: { value: 0.0, attributes: { readOnly: false, focus: false, label: '', float: 'right', hidden: 'unset' } },
        TipoReversion: { value: "", attributes: { readOnly: false, focus: false, label: "", hidden: "unset", }, },
        pNumero: { value: "", attributes: { readOnly: false, focus: false, label: "", hidden: "unset", }, },
        pFecha: { value: new Date(1900, 1, 1), attributes: { readOnly: false, focus: false, label: "", hidden: "unset", minDate: fechaPrimerDia(new Date(Config.anoAntiguedad, 0, 1)), maxDate: fechaUltimoDia(new Date(_AnnoActual, 11, 1)), ListaAnnos: _ListaAnnos, formatDate: Config.formatoMesAno }, },
    }

    const [listaTipoAS, setListaTipoAS] = useState([]);
    const listaEstado = Config.listaEstadoAsientos;

    const [datos, setDatos] = useState(datosConst);
    const [selectedEstado, setSelectedEstado] = useState(itemSelect(1, listaEstado));
    const [selectedTipoA, setSelectedTipoA] = useState(null);
    const [filaSeleccionada, setFilaSeleccionada] = useState(undefined);
    const listaTipoReversion = [
        { value: "D", text: "Desaplicarlo para editarlo" },
        { value: "G", text: "Generar un asiento de reversión" },
    ];
    const [tipoReversion, setTipoReversion] = useState(listaTipoReversion[0].value);
    const [selectModalReversion, setSelectModalReversion] = useState(false);
    const [selectModalMoverMes, setSelectModalMoverMes] = useState(false);

    const [spinnerModal, setSpinnerModal] = useState(undefined);
    const [spinnerLabel, setSpinnerLabel] = useState('');
    const [spinnerTipo, setSpinnerTipo] = useState(1);

    const localStorage = new LocalStorage();
    const SessionStorage = new Session();

    //Seguridad
    const [usuarioS, setUsuarioS] = useSessionStorage('UsuarioSCON');
    const [menuId, setMenuId] = useState(0);
    const [menuOpciones, setMenuOpciones] = useState([]);
    const [showModalSeguridad, setShowModalSeguridad] = useState(false);
    const [opcionValidar, setOpcionValidar] = useState(0);
    const [opcionValidarNombre, setOpcionValidarNombre] = useState('');

    const ubicacionRef = useRef();
    const empresaRef = useRef();


    const botones = [
        /*{
            name: "btnHomeC",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => volverAtras(),
            leyenda: "",
            iclase: faReply,
            tooltip: "Volver"
        },*/ {
            name: "btnLiqModificarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleModificar(),
            leyenda: "",
            iclase: faPencilAlt,
            tooltip: "Modificar"

        }, {
            name: "btnGuardarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleNuevo(),
            leyenda: "",
            iclase: faPlus,
            tooltip: "Agregar Nuevo"
        }, {
            name: "btnExportExcelAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleExportarAExcel(),
            leyenda: "",
            iclase: faUpload,
            tooltip: "Exportar a Excel"

        }, {
            name: "btnImportExcelAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleImportarExcel(),
            leyenda: "",
            iclase: faDownload,
            tooltip: "Importar de Excel"
        },
        {
            name: "btnPrintAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleVerDetalle(),
            leyenda: "",
            iclase: faListAlt,
            tooltip: "Ver Asiento"
        }
    ]

    const botonesLista = [
        {
            name: "btnDigitarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleDigitar(),
            leyenda: "",
            iclase: faDigitalTachograph,
            tooltip: "Digitar"
        }, {
            name: "btnAprobarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleAprobar(),
            leyenda: "",
            iclase: faCheck,
            tooltip: "Aprobar"

        }, {
            name: "btnAplicarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleAplicar(),
            leyenda: "",
            iclase: faCheckDouble,
            tooltip: "Aplicar"
        }, {
            name: "btnAnularAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleAnular(),
            leyenda: "",
            iclase: faTimes,
            tooltip: "Anular"

        }, {
            name: "btnReversarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleModalReversar(),
            leyenda: "",
            iclase: faUndoAlt,
            tooltip: "Reversar"
        },
        {
            name: "btnMoverMesAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => handleModalMoverMes(),
            leyenda: "",
            iclase: faCalendarAlt,
            tooltip: "Mover al Mes"
        }
    ]

    const botonFiltro = [

        {
            name: "btnRefescarAs",
            clase: "btn btn-sm pull-right flipInX animated",
            evento: () => cargaLista(),
            leyenda: "",
            iclase: faSync,
            tooltip: "Refrescar"
        },
    ]

    const selectRowAS = {
        mode: 'radio', hideSelectColumn: true, bgColor: '#d73220',
        style: { color: '#ffffff' }, clickToSelect: true, classes: "colorListAs",
        onSelect: (row, isSelected) => onRowSelectDet(row, isSelected)
    };

    const handleExportarAExcel = async () => {
        try {
            if (filaSeleccionada) {
                const result = await EncabezadoAsiento_ExportarAExcel_Request(token, empresa, filaSeleccionada.id);

                const outputFilename = `Asiento_${filaSeleccionada.id}.xlsx`;

                const url = window.URL.createObjectURL(result.data);
                console.log(`ReporteGeneralDePlanillaCreaExcel : downloadUrl : ${JSON.stringify(url)}`);

                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', outputFilename);
                document.body.appendChild(link);
                link.click();

            } else {
                Notificacion.warning('Debe seleccionar un registro.');
            }
        }
        catch (ex) {
            Notificacion.error('Ocurrió un error generando el archivo.')
        }
    }

    const handleImportarExcel = async () => {

        if (filaSeleccionada) {
            historyMenu.push(`${SiteRutas.CargaAsientoExcel}/${filaSeleccionada.id}`);
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }
    }

    const handleModalReversar = () => {
        if (filaSeleccionada) {
            if (filaSeleccionada.Estado == Config.eaAplicado) {
                const id = filaSeleccionada.id;
                const Num = filaSeleccionada.pNumero;
                const Fecha = filaSeleccionada.Fecha;
                let _datos = { ...datos };

                _datos.pFecha.value = moment(filaSeleccionada.Fecha).toDate();
                _datos.pNumero.value = filaSeleccionada.pNumero;
                setDatos(_datos);

                if (Fecha < datosEmpresa.Periodo) {
                    Notificacion.warning('No se pueden reversar asientos de meses cerrados.');
                } else {
                    const optSegopt = optSeg.TOpciones_Menu;
                    const _value = optSegopt.Reversar.value;
                    let validar = validarMenuOpcion(_value);
                    if (!validar) {
                        setSelectModalReversion(true);
                    }
                }
            } else {
                Notificacion.warning('No se puede Reversar este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    }

    const handleReversar = async () => {

        const _tipoReversion = tipoReversion === listaTipoReversion[0].value ? true : false;
        console.log(`reversando empresa = ${empresa}`);
        const response = await EncabezadoAsiento_Reversar_Request(token, empresa, filaSeleccionada.id, _tipoReversion, filaSeleccionada.Fecha, usuario);
        console.log(`reversado`);

        if (response.Exitoso) {

            setSelectModalReversion(false);
            Notificacion.success('Proceso de reversión realizado correctamente.');

        } else {
            Notificacion.error(`Error: ${response.Mensaje}`);
        }

    }

    const handleModalMoverMes = () => {
        if (filaSeleccionada) {
            if (filaSeleccionada.Estado == Config.eaDigitado || filaSeleccionada.Estado == Config.eaAprobado) {

                let _datos = { ...datos };

                _datos.pFecha.value = moment(filaSeleccionada.Fecha).toDate();
                _datos.pNumero.value = filaSeleccionada.pNumero;

                setDatos(_datos);


                const optSegopt = optSeg.TOpciones_Menu;
                const _value = optSegopt.MoverAlMes.value;
                let validar = validarMenuOpcion(_value);
                if (!validar) {
                    setSelectModalMoverMes(true);
                }

            } else {
                Notificacion.warning('No se puede Mover de Mes este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    }

    const handleAprobar = () => {

        if (filaSeleccionada) {
            if (filaSeleccionada.Estado === Config.eaDigitado) {

                const optSegopt = optSeg.TOpciones_Menu;
                let validar = validarMenuOpcion(optSegopt.Aprobar.value);
                if (!validar) {
                    handleAprobarSel();
                }

            } else {
                Notificacion.warning('No se puede Aprobar este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    }

    const handleDigitar = () => {

        if (filaSeleccionada) {
            if (filaSeleccionada.Estado === Config.eaAprobado || filaSeleccionada.Estado === Config.eaAnulado) {

                const optSegopt = optSeg.TOpciones_Menu;
                let validar = validarMenuOpcion(optSegopt.Digitar.value);
                if (!validar) {
                    handleDigitarSel();
                }

            } else {
                Notificacion.warning('No se puede cambiar a Digitado este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    };

    const handleAplicar = () => {

        if (filaSeleccionada) {
            if (filaSeleccionada.Estado === Config.eaAprobado) {

                const optSegopt = optSeg.TOpciones_Menu;
                let validar = validarMenuOpcion(optSegopt.Aplicar.value);
                if (!validar) {
                    handleAplicarSel();
                }

            } else {
                Notificacion.warning('No se puede Aplicar este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    };

    const handleAnular = () => {

        if (filaSeleccionada) {
            if (filaSeleccionada.Estado === Config.eaAprobado || filaSeleccionada.Estado === Config.eaDigitado) {

                const optSegopt = optSeg.TOpciones_Menu;
                let validar = validarMenuOpcion(optSegopt.Anular.value);
                if (!validar) {
                    handleAnularSel();
                }

            } else {
                Notificacion.warning('No se puede Anular este asiento en su estado actual.');
            }
        } else {
            Notificacion.warning('Debe seleccionar un registro.');
        }

    };

    const handleAprobarSel = () => {

        let resultado = false;

        Swal.fire({
            title: 'Aprobar',
            html: '<h4>¿Está seguro de cambiar el estado al asiento seleccionado?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                Aprobar();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

    };

    const handleAplicarSel = () => {

        let resultado = false;

        Swal.fire({
            title: 'Aplicar',
            html: '<h4>¿Está seguro de cambiar el estado al asiento seleccionado?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                Aplicar();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

    }

    const handleDigitarSel = () => {

        let resultado = false;

        Swal.fire({
            title: 'Digitar',
            html: '<h4>¿Está seguro de cambiar el estado al asiento seleccionado?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                Digitar();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

    };

    const handleAnularSel = () => {

        let resultado = false;

        Swal.fire({
            title: 'Anular',
            html: '<h4>¿Está seguro de cambiar el estado al asiento seleccionado?',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10a599',
            cancelButtonColor: '#d33',
            confirmButtonText: '<h5><i class="fa fa-check fa-fw"></i> Sí</h5>',
            cancelButtonText: '<h5><i class="fa fa-remove fa-fw"></i> No</h5>',
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.value) {
                resultado = true;
                Anular();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                resultado = false;
            }
        });

    };

    const Aprobar = async () => {
        await cambiarEstado(Config.eaAprobado);
    };

    const Digitar = async () => {
        await cambiarEstado(Config.eaDigitado);
    };

    const Aplicar = async () => {
        spinnerModalMostrar(true, `Aplicando asientos que cumplen con los criterios seleccionados`, 3);
        const response = await EncabezadoAsiento_Aplicar_Request(token, empresa, filaSeleccionada.id, true, false, false, datos.fecMesAno.value, 0, 0, filaSeleccionada.Tipo, usuario);
        spinnerModalMostrar(false, '', 3);

        if (response.Exitoso) {
            Notificacion.success(`Proceso realizado satisfactoriamente.`);
        } else {
            Notificacion.error(`Error: ${response.Mensaje}`);
        }
    };

    const Anular = async () => {
        await cambiarEstado(Config.eaAnulado);
    };

    const handleNuevo = () => {
        historyMenu.push(`${SiteRutas.MantAsientos}/0/0`);
    };

    const handleModificar = () => {

        if (filaSeleccionada) {
            historyMenu.push(`${SiteRutas.MantAsientos}/${filaSeleccionada.id}/0`);
        } else {
            Notificacion.error(`Debe seleccionar un registro.`);
        }

    };

    const handleVerDetalle = () => {

        if (filaSeleccionada) {
            historyMenu.push(`${SiteRutas.DetalleAsiento}/${filaSeleccionada.id}`);
        } else {
            Notificacion.error(`Debe seleccionar un registro.`);
        }

    };

    const spinnerModalMostrar = (pSpinnerModal, pSpinnerLabel, pSpinnerTipo) => {
        setSpinnerModal(pSpinnerModal);
        setSpinnerLabel(pSpinnerLabel);
        setSpinnerTipo(pSpinnerTipo);
    };

    //Seguridad
    const cargarMenuOpciones = async (pModuloId, pUsuarioId, pMenuId) => {
        try {

            let listMO = await Obtener_MenuOpciones_Lista_Request(token, pModuloId, pUsuarioId, pMenuId);
            if (listMO.Exitoso === false) {
                return null;
            }
            return listMO.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuOpciones.`);
        }
    };

    const cargarMenuNombre = async (pModulo, pMenuNombre) => {
        try {
            let listMON = await Obtener_MenuNombre_Request(token, pModulo, pMenuNombre);
            if (listMON.Exitoso == false) {
                return null;
            }
            return listMON.Datos;
        }
        catch (err) {
            Notificacion.error(`Error: cargarMenuNombre.`);
        }
    };

    const validarMenuOpcion = (pOpcion) => {        
        let validar = false;
        let _menuOpciones = menuOpciones;
        const optSegopt = optSeg.TOpciones_Menu;
        let resultado = _menuOpciones.filter((item) => item.Opcion_Nombre == pOpcion);
        if (resultado.length > 0) {
            if (resultado[0].Opcion_Validar) {
                setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
                validar = true;
            }
        } else {
            setShowModalSeguridad(true); setOpcionValidar(resultado[0].Opcion_Id); setOpcionValidarNombre(pOpcion);
            validar = true;
            //Notificacion.error('No existe opción en la seguridad');
        }
        return validar;
    };

    const handleCerrarModal = () => setShowModalSeguridad(false);

    const handleCerrarModalMoverMes = () => setSelectModalMoverMes(false);

    const cerrarModal = () => {

        setSelectModal(false);
        setSelectedCentroCosto(undefined);
        setIndexCost(indexCost);
        setRowSelected(undefined);

    }

    const onActionResultModal = (pValido) => {
        if (pValido) {
            let _OpcionNom = opcionValidarNombre;
            setShowModalSeguridad(false); setOpcionValidar(0); setOpcionValidarNombre('');
            const _optSegopt = optSeg.TOpciones_Menu;
            switch (_OpcionNom) {
                case _optSegopt.Aprobar.value:
                    handleAprobarSel();
                    break;
                case _optSegopt.Aplicar.value:
                    handleAplicarSel();
                    break;
                case _optSegopt.Anular.value:
                    handleAnularSel();
                    break;
                case _optSegopt.Digitar.value:
                    handleDigitarSel();
                    break;
                case _optSegopt.Reversar.value:
                    console.log(`onActionResultModal  comentado`);
                    setSelectModalReversion(true);
                    break;
                case _optSegopt.MoverAlMes.value:
                    setSelectModalMoverMes(true);
                    break;
                default:
                    break;
            }
        }
    }

    const cambiarEstado = async (Estado) => {
        let _Mensaje = '';
        let _Cambiar = false;

        if (filaSeleccionada) {

            _Cambiar = true;

            if (filaSeleccionada.Estado === Config.eaDigitado && filaSeleccionada.Tipo_Anulacion === Config.anMovMes) {
                _Cambiar = false;
                // si se quiere poner en digitado un asiento que fue anulado por movimiento de mes.
                _Mensaje = 'Este asiento fue generado al realizar el movimiento del asiento hacia otro mes, ';
                _Mensaje = _Mensaje + 'la digitación del mismo puede generar diferencias contables, ';
                _Mensaje = _Mensaje + 'por lo que no se puede cambiar su estado.';

                Notificacion.warning(_Mensaje);
            }
            //si se puede cambiar el estado abrir formulario de cambio de estado
            if (_Cambiar) {
                let pDatos = { ...filaSeleccionada }
                pDatos.AprobadoX = usuario;
                pDatos.Modificado = usuario;
                pDatos.AnuladoX = usuario;
                pDatos.DigitadoX = usuario;
                pDatos.Usuario_Modifica = usuario;
                pDatos.Fecha = datos.fecMesAno.value;
                const _Estado = itemSelect(Estado, Config.listaEstadoAsientos);

                spinnerModalMostrar(true, `Cambiando Estado a: ${_Estado.label}`, 3);
                const response = await EncabezadoAsiento_ModificarEstado_Request(token, pDatos, Estado, false, true, false, pDatos.Numero, pDatos.Numero, new Date(), new Date());
                spinnerModalMostrar(false, '', 3);

                if (response.Exitoso) {
                    Notificacion.success(`El Estado fue actualizado correctamente a ${_Estado.label}.`);
                    setFilaSeleccionada(undefined);
                    await cargaLista();
                } else {
                    Notificacion.error(`Error: ${response.Mensaje}`);
                }
            }
        } else {
            Notificacion.error(`Debe seleccionar un registro.`);
        }
    }

    useEffect(() => {

        if (!mounted.current) {
            const carga = async () => {
                await cargarDatos()
            }
            carga();
            mounted.current = true;
            empresaRef.current = SessionStorage.get('empresaCON');
        } else {
            const _emp = SessionStorage.get('empresaCON');
            if ((_emp != empresaRef.current)) {
                empresaRef.current = _emp;
                const carga2 = async () => {
                    await cargarDatos()
                }
                carga2();
            }
        }
    });

    const cargarDatos = async () => {

        let spinnerLabel = 'Cargando datos...';
        spinnerModalMostrar(true, spinnerLabel, 3)

        const _MenuNomb = await cargarMenuNombre(Config.Modulo, optSeg.TMenuSistema.Asientos.value);
        let _menuId = 0;

        if (_MenuNomb.ID != undefined) {
            _menuId = _MenuNomb.ID;
        }
        const _UsuarioS = usuarioS;
        let _menuOpciones = null;
        if (_menuId > 0) {
            _menuOpciones = await cargarMenuOpciones(Config.Modulo, _UsuarioS, _menuId);
        }
        setMenuId(_menuId), setMenuOpciones(_menuOpciones)

        let _Empresa1 = SessionStorage.get('empresaCON');
        if ((_Empresa1 == null) || (_Empresa1 == undefined) || (_Empresa1.length == 0)) {
            _Empresa1 = 0;
        }

        if (_Empresa1 !== 0 && _Empresa1 !== undefined) {

            let _Empresa = [];

            _Empresa = await cargarEmpresa(_Empresa1);
            let _Datos = { ...datos }
            _Datos.fecMesAno.value = new Date(_Empresa.Periodo);
            setDatosEmpresa(_Empresa);
            setDatos(_Datos);

            let tiposAs = await cargarTiposAsiento(_Empresa1);

            await cargarAsientos(selectedEstado.value, _Datos.fecMesAno.value, tiposAs[0].value, _Empresa1);
        }

        spinnerModalMostrar(false, '', 3)
    };

    const cargaLista = async () => {
        let spinnerLabel = 'Cargando datos...';
        spinnerModalMostrar(true, spinnerLabel, 3);
        let _Empresa = empresa !== 0 ? empresa : SessionStorage.get('empresaCON');

        await cargarAsientos(selectedEstado.value, datos.fecMesAno.value, selectedTipoA.value, _Empresa);
        spinnerModalMostrar(false, '', 3);
    };

    const volverAtras = () => {
        historyMenu.push(SiteRutas.Login);
    }
    const cargarTiposAsiento = async (pEmpresa) => {
        if (pEmpresa !== 0) {
            const response = await TipoAsiento_Listar_Request(token, pEmpresa);
            let lista = [{ value: 0, label: "Todos" }];
            if (response.Exitoso) {
                if (Array.isArray(response.Datos) && response.Datos.length > 0) {
                    response.Datos.map(x => (lista.push({ value: x.ID, label: x.Nombre, mensual: x.Mensual })));
                    setListaTipoAS(lista);
                    setSelectedTipoA(lista[0]);

                } else {
                    //volverAtras();
                    setListaTipoAS(lista);
                    setSelectedTipoA(lista[0]);
                }

            }
            else {
                Notificacion.error(response.Mensaje);
                //volverAtras();
                setListaTipoAS(lista);
                setSelectedTipoA(lista[0]);
            }
            return lista;
        }
    };


    const cargarEmpresa = async (pEmpresa) => {
        let response = await Empresa_Consulta_Request(token, pEmpresa);

        if (response.Exitoso) {
            return (response.Datos);
        } else {
            Notificacion.error(response.Mensaje);
            volverAtras();
        }
        return [];
    }
    const cargarAsientos = async (pEstado, pFecha, pTipoA, pEmpresa) => {
        const response = await EncabezadoAsiento_Listar_Request(token, pEmpresa, pEstado, pFecha, pTipoA);
        let lista = [];
        if (response.Exitoso) {
            if (Array.isArray(response.Datos) && response.Datos.length > 0) {
                lista = response.Datos;

            } else {
                volverAtras();
            }

        }
        else {
            Notificacion.error(response.Mensaje);
            //volverAtras();
        }
        setListaGralAs(lista);

    }


    const onRowSelectDet = (row, isSelect) => {

        setFilaSeleccionada(row);
        return true;
    }

    const cellEditAS = { mode: 'click', blurToSave: true, autoSelectText: true };

    const handleCerrarModalReversion = () => setSelectModalReversion(false);

    const onhandleChangeDate = async (date, id) => {
        const name = id;
        const value = date;
        let newAttributes = datos[name].attributes;

        const _Datos = Object.assign({}, datos, { [name]: { value: value, attributes: newAttributes } });

        setDatos(_Datos);

        if (id !== "pFecha") {
            setListaGralAs([]);
        }
    }

    const onhandleSelectedEstado = (selSeccion) => { setSelectedEstado(selSeccion); setListaGralAs([]); };
    const onhandleSelectedTipoA = (selSeccion) => { setSelectedTipoA(selSeccion); setListaGralAs([]); };

    const handleRadioButtonTipo = (e, id) => {
        console.log('handleRadioButtonTipo');

        console.log(`handleRadioButtonTipo id: ${id}, e: ${JSON.stringify(e.target.value)}`);
        const name = id;
        const valor = e.target.value;

        setTipoReversion(valor);

    };

    const handleMoverAlMes = async () => {

        const fila = { ...filaSeleccionada };

        fila.Fecha = datos.pFecha.value;
        fila.AnuladoX = usuario;
        fila.Usuario_Modifica = usuario;
        fila.Tipo_Anulacion = Config.anMovMes;

        spinnerModalMostrar(true, 'Cambiando Mes', 3);
        const response = await EncabezadoAsiento_CambiarMes_Request(token, fila);
        spinnerModalMostrar(false, '', 3);

        if (response.Exitoso) {

            setSelectModalReversion(false);
            await cargaLista();
            Notificacion.success('Proceso de Cambio de Mes realizado correctamente.');

        } else {

            Notificacion.error(`Error: ${response.Mensaje}`);

        }

    }

    const verificarInicio = (fecha) => {
        let res = true;

        if (fecha.getFullYear() < datosEmpresa.InicioPeriodo.getFullYear())
            res = false
        else
            if (fecha.getFullYear() < datosEmpresa.InicioPeriodo.getFullYear() && fecha.getMonth() < datosEmpresa.InicioPeriodo.getMonth())
                res = false;

        return res;
    }

    const rowEventsAS = {
        onDoubleClick: (e, row, rowIndex) => {
            handleModificar();
        }
    };

    return (
        <Fragment>

            <ListaAsientosInt
                titulo={"Asientos Contables"}
                Datos={datos}
                botones={botones}
                botonesLista={botonesLista}
                botonFiltro={botonFiltro}
                selectRowAS={selectRowAS}
                cellEditAS={cellEditAS}
                rowEventsAS={rowEventsAS}
                listaGralAs={listaGralAs}
                columnasAS={columnasAS}
                listaTipoAS={listaTipoAS}
                listaEstado={listaEstado}
                selectedEstado={selectedEstado}
                selectedTipoA={selectedTipoA}
                onhandleChangeDate={onhandleChangeDate}
                onhandleSelectedEstado={onhandleSelectedEstado}
                onhandleSelectedTipoA={onhandleSelectedTipoA}
            />
            <ModalSpinner
                selectedModal={spinnerModal}
                contentLabel={'spinnerModalProgress'}
                label={spinnerLabel}
                tipoSpinner={spinnerTipo}
            />
            <ModalSeguridad
                modalTitle={'Requiere Permisos'}
                menuId={menuId}
                opcionId={opcionValidar}
                show={showModalSeguridad}
                onActionResult={onActionResultModal}
                onHide={handleCerrarModal}
            />
            <ModalReversion
                showModal={selectModalReversion}
                contentLabel={''}
                cerrarModal={handleCerrarModalReversion}
                Datos={datos}
                handleRadioButtonTipo={handleRadioButtonTipo}
                listaTipoReversion={listaTipoReversion}
                tipoReversion={tipoReversion}
                handleReversar={handleReversar}
            />
            <ModalMoverMes
                showModal={selectModalMoverMes}
                contentLabel={''}
                cerrarModal={handleCerrarModalMoverMes}
                Datos={datos}
                onhandleChangeDate={onhandleChangeDate}
                handleAceptar={handleMoverAlMes}
            />
            <BotonArriba Delay={10} Visible={100} />
        </Fragment>

    );
};
export default withRouter(memo(listaAsientos));